import { useParams } from "react-router-dom";
import FormCodSistema from "./formulario";
// import FormEmpresa from "./components/formulario";

export function CodigiodoSistemaEditar() {
  const idcodigo = useParams();
  return (
    <>
      <div className="container-fluid mt-2">
        <FormCodSistema idcodigo={idcodigo.id} acao="Editar" />
      </div>
    </>
  );
}
